'use es6';

import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { Component } from 'react';
export default ((...decorators) => WrappingComponent => {
  var _class, _temp;

  return _temp = _class = class extends Component {
    constructor(...args) {
      super(...args);

      this.renderLayers = () => {
        return decorators.map((Decorator, index) => /*#__PURE__*/_jsx(Decorator, Object.assign({}, this.props), index));
      };
    }

    render() {
      return /*#__PURE__*/_jsxs("div", {
        className: "layer-decorator",
        children: [/*#__PURE__*/_jsx(WrappingComponent, Object.assign({}, this.props)), this.renderLayers()]
      });
    }

  }, _class.displayName = `LayerDecorator(${WrappingComponent.displayName})`, _temp;
});